import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import "./CTAButton.css";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const BASE_URL = "https://atlastravelhouse.com";


function PopupCTA() {
  const [popup, setPopup] = useState(null);
  useEffect(() => {
  let interval;

  const fetchPopup = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/popup/random/`);
      setPopup(res.data);
    } catch (err) {
      console.error("Error fetching popup:", err);
    }
  };

  const timeout = setTimeout(() => {
    fetchPopup(); 
    interval = setInterval(fetchPopup, 600000);
  }, 600000);

  return () => {
    clearTimeout(timeout);
    clearInterval(interval);
  };
}, []);


  if (!popup) return null;

  const { title, image1, image2, image3 } = popup;
  const getFullUrl = (image) => (image ? `${BASE_URL}${image}` : null);

  return (
    <AnimatePresence>
      {popup && (
        <motion.div
          className="popup-cta-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="popup-cta"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: "spring", stiffness: 120, damping: 20 }}
          >
            <button className="close-btn" onClick={() => setPopup(null)}>
              ×
            </button>
            <h3>{title}</h3>
            <div className="popup-images">
              {image1 && <img src={getFullUrl(image1)} alt="popup-img1" />}
              {image2 && <img src={getFullUrl(image2)} alt="popup-img2" />}
              {image3 && <img src={getFullUrl(image3)} alt="popup-img3" />}
            </div>
            <a href="tel:+919971881444" className="call-btn">
              📞 Call Now
            </a>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PopupCTA;
